import { useEffect, useRef } from "react";
import { gsap } from "gsap";

const SmokeCursor = () => {
  const canvasRef = useRef(null);
  const particles = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const createParticle = (x, y) => {
      let particle = {
        x,
        y,
        size: Math.random() * 15 + 10, // Softer, larger particles
        alpha: 0.8, // Start with more transparency
        speedX: (Math.random() - 0.5) * 1, // Slow horizontal drift
        speedY: Math.random() * -1 - 0.2, // Slow upward motion
        swirl: (Math.random() - 0.5) * 0.3, // Subtle swirling effect
      };

      gsap.to(particle, {
        alpha: 0, // Smooth fade-out
        duration: 2.5, // Slower fade for realism
        ease: "power1.out",
        onComplete: () => {
          particles.current = particles.current.filter((p) => p !== particle);
        },
      });

      return particle;
    };

    const updateParticles = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      particles.current.forEach((p) => {
        p.x += p.speedX + Math.sin(p.swirl);
        p.y += p.speedY;

        ctx.globalAlpha = p.alpha;
        const gradient = ctx.createRadialGradient(
          p.x,
          p.y,
          1,
          p.x,
          p.y,
          p.size
        );
        gradient.addColorStop(0, "rgba(200, 200, 200, 0.2)"); // Lighter gray
        gradient.addColorStop(1, "rgba(200, 200, 200, 0)"); // Fades out

        ctx.fillStyle = gradient;
        ctx.beginPath();
        ctx.ellipse(
          p.x,
          p.y,
          p.size,
          p.size * 1.3,
          Math.random() * Math.PI,
          0,
          Math.PI * 2
        );
        ctx.fill();
      });

      requestAnimationFrame(updateParticles);
    };

    const handleMouseMove = (e) => {
      for (let i = 0; i < 3; i++) {
        particles.current.push(createParticle(e.clientX, e.clientY));
      }
    };

    window.addEventListener("mousemove", handleMouseMove);
    updateParticles();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    ></canvas>
  );
};

export default SmokeCursor;
